firebird.controller('webinarOptionsModalCtrl', [
    '$scope',
    'logService',
    'socketService',
    'meetingService',
    'localizationService',
    function ($scope, logService, socketService, meetingService, localizationService) {
        var self = this;
        const logger = logService.createLoggerWithSource('webinarOptionsModalCtrl');

        self.modalState = 'closed';
        self.options = meetingService.getWebinarOptions();
        self.attendeeListAllowed = meetingService.isWebinarAttendeeListAllowed();

        self.onCheckboxToggled = onCheckboxToggled;

        self.getPrivateChatOnlyTooltip = getPrivateChatOnlyTooltip;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        ////////////////////////

        function onShowModal(e, modalName) {
            if (modalName === 'webinarOptions') {
                self.modalState = 'open';
                digest();
            }
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('webinarOptionsModalCtrl') !== -1) {
                self.modalState = 'closed';
                digest();
            }
        }

        function onCheckboxToggled(optionName) {
            logger.log('Webinar Options - Checkbox toggled:', optionName, self.options[optionName]);

            socketService.send({
                message: 'webinar-options-updated',
                data: {
                    options: self.options
                }
            });
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function getPrivateChatOnlyTooltip() {
            return !self.options.showPublicChat
                ? localizationService.translate(
                      'WEBINAR_OPTIONS.TOOLTIP.PUBLIC_CHAT_MUST_BE_ENABLED_TO_USE_THE_PRIVATE_CHAT_ONLY_FEATURE'
                  )
                : '';
        }
    }
]);
